import React from 'react';
import classes from "./Admin.module.scss";

const Admin = () => {
    return (
        <>
            <h1>Устройства</h1>
            <div className={classes.container}>
            </div>
        </>
    );
};

export default Admin;